export const AUTH_TOKEN_STORAGE_KEY = "openappcart_token";

export function readAuthTokenFromStorage(
  storage: Pick<Storage, "getItem"> = localStorage,
): string | null {
  return storage.getItem(AUTH_TOKEN_STORAGE_KEY);
}

export function writeAuthTokenToStorage(
  token: string,
  storage: Pick<Storage, "setItem"> = localStorage,
): void {
  storage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
}

export function clearAuthSessionStorage(
  storage: Pick<Storage, "removeItem"> = localStorage,
): void {
  storage.removeItem(AUTH_TOKEN_STORAGE_KEY);
}
